import type { TriggerEvent } from '@omen-quest/grid-map';
import type { DialogueState } from '@/components/game-ui/DialogueOverlay';

// ============================================================================
// TYPES
// ============================================================================

export interface CustomTriggerEvent {
  eventName: string;
  data?: Record<string, unknown>;
}

// ============================================================================
// HELPERS
// ============================================================================

/**
 * Processes a list of TriggerEvents into a dialogue state (first displayable
 * event) and any custom events that need further handling (e.g. AI triggers).
 */
export function processEvents(events: TriggerEvent[]): {
  dialogue: DialogueState | null;
  customEvents: CustomTriggerEvent[];
} {
  let dialogue: DialogueState | null = null;
  const customEvents: CustomTriggerEvent[] = [];

  for (const event of events) {
    switch (event.effect.type) {
      case 'dialogue':
        if (!dialogue) {
          dialogue = {
            text: event.effect.text,
            speaker: event.effect.speaker,
            variant: 'dialogue',
          };
        }
        break;
      case 'trap':
        if (!dialogue) {
          dialogue = {
            text: event.effect.description ?? 'You triggered a trap!',
            variant: 'trap',
          };
        }
        break;
      case 'teleport':
        if (!dialogue) {
          dialogue = {
            text: 'The world shifts around you...',
            speaker: 'Narrator',
            variant: 'dialogue',
          };
        }
        break;
      case 'spawn':
        if (!dialogue) {
          dialogue = {
            text: 'Something stirs in the shadows...',
            speaker: 'Narrator',
            variant: 'dialogue',
          };
        }
        break;
      case 'custom':
        customEvents.push({
          eventName: event.effect.eventName,
          data: event.effect.data,
        });
        break;
      case 'combat':
        break;
    }
  }

  return { dialogue, customEvents };
}
